module.exports = __webpack_public_path__ + "4af3fdc876f1a11eb817eed665d5f711.jpg";